interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

function getPages(current: number, total: number): (number | string)[] {
  const pages: (number | string)[] = [];
  if (total <= 7) {
    for (let i = 1; i <= total; i += 1) pages.push(i);
    return pages;
  }
  pages.push(1);
  if (current > 3) pages.push("...");
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (current < total - 2) pages.push("...");
  pages.push(total);
  return pages;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = getPages(current, total);

  const btnBase =
    "flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm transition-colors cursor-pointer";

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${btnBase} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-500 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line" />
        <span className="ml-1 hidden sm:inline">上一页</span>
      </button>

      {pages.map((p, idx) =>
        typeof p === "number" ? (
          <button
            key={`p-${p}`}
            type="button"
            onClick={() => onChange(p)}
            className={`${btnBase} ${
              p === current
                ? "bg-primary-500 font-medium text-foreground-950"
                : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-500"
            }`}
          >
            {p}
          </button>
        ) : (
          <span
            key={`dots-${idx}`}
            className="flex h-9 min-w-9 items-center justify-center text-foreground-500"
          >
            ···
          </span>
        )
      )}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className={`${btnBase} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-500 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <span className="mr-1 hidden sm:inline">下一页</span>
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}